export const ALIVE_CHECK_CONSTANT = 1524155677480;
export const AUTOMATION_PASSWORD_CONSTANT = "test321";
export const ROAMER_SUFFIX_CONST = "@oiwifi-roaming";
export const ROAMER_PREFIX_CONST = "boingo/vex!";

export const BW_PROMO_CONFIG_DEFAULT = {
  session_timeout: "10080",
  media_session_timeout: "10080",
  session_retake: "0",
  connect_cap: "1",
  mikrotik_group: "Promo",
  idle_timeout: "10080",
  download_speed: "10M",
  upload_speed: "10M",
  burst_speed: "10M",
  burst_duration: "5",
  campaign_type: "0",
  campaign_id: "",
  use_campaign_id_in_auth: "false",
};

export const BW_PROMO_DEGRADED_CONFIG_DEFAULT = {
  session_timeout: "0",
  media_session_timeout: "0",
  session_retake: "0",
  connect_cap: "1",
  idle_timeout: "0",
  burst_duration: "0",
  campaign_type: "5",
  campaign_id: "",
  use_campaign_id_in_auth: "false",
};

export const WEB_PORTAL_PRODUCT_TYPES = {
  military: "military",
  retail: "retail",
  ps: "ps",
  lounges: "lounges",
};
